<div class="container mt-4">
    <div class="row">
        <div class="col-md-12 text-center">
            <div class="card shadow">
                <div class="card-body">
                    <h1>Page not found</h1>
                    <div class="mt-4">
                        <app-button buttonText="Go Back" buttonSize="lg" buttonColor="primary" customCssClass="mb-4"
                            (onClickedEvent)="onGoBackClicked()"></app-button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>